import { css } from 'emotion'

export const SelectTagInputFieldStyles = css``
